import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';

import ActionButton from 'components/buttons/ActionButton';
import SubUserRolesDialog from './SubUserRolesDialog';

const CreateSubUserButton = ({ tenantId }) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ActionButton onClick={handleOpen} startIcon={<AddIcon />}>
        New User
      </ActionButton>

      {open && <SubUserRolesDialog open={open} onClose={handleClose} tenantId={tenantId} />}
    </>
  );
};

export default CreateSubUserButton;
